import {useEffect} from "react";
import {connect} from "react-redux";
import {LOOK_OVERLAYS} from "../../core/constants";
import {setLookLockedTutorial} from "../../../../actions/lookFunctions";
import {getFeatureIsLocked} from "../../../../misc/helpers";
import PropTypes from "prop-types";
import {navItemInterface} from "../../../../interfaces/featureInterface";
import {wizardGroupInterface} from "../../../../interfaces/wizardItemInterface";


const LookLockTutorialCaller = (props) => {

  const {fabricatorData, navItems, isPhoneNumberValidated, lookLockedTutorial, setLookLockedTutorial, wizardGroup,
    lookOverlayOpened} = props;


  useEffect(() => {
    if (!navItems || !navItems.length || !fabricatorData.settings.leadCapture || lookLockedTutorial.finished
      || (wizardGroup && wizardGroup.skipLockDontApply)
      || lookLockedTutorial.visible
      || isPhoneNumberValidated || (lookOverlayOpened && (lookOverlayOpened === LOOK_OVERLAYS.intro))) {
      return
    }
    const firstLockedIndex = navItems.findIndex(navItem => getFeatureIsLocked(navItem.part));
    const firstUnlockedIndex = navItems.findIndex(navItem => !getFeatureIsLocked(navItem.part));
    if (firstLockedIndex === -1 || firstUnlockedIndex === -1) {
      return;
    }
    setLookLockedTutorial({
      visible: true,
      withGrid: true,
      firstLockedIndex,
      firstUnlockedIndex,
    })
  }, [navItems, fabricatorData, isPhoneNumberValidated, lookLockedTutorial, setLookLockedTutorial,
    lookOverlayOpened, wizardGroup]);

  return null

};

LookLockTutorialCaller.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape(navItemInterface)).isRequired,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store) => {
  const {lookOverlayOpened, lookLockedTutorial} = store.lookState;
  const {isMobile, visualizersLoaded} = store.serverState;

  return {
    fabricatorData: store.fabricatorState,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
    lookLockedTutorial,
    lookOverlayOpened,
  };
};

const mapDispatchToProps = {
  setLookLockedTutorial,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookLockTutorialCaller)

